import { createAction, props } from '@ngrx/store';

import { CustomPDFReportStore } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/interfaces/custom-pdf-report-store.interface';

export const setCustomPDFReportStore = createAction(
    '[Custom PDF Report Builder] Set Report Store',
    props<CustomPDFReportStore>()
);
